import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';
import { toast } from 'ngx-sonner';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      console.error('Error Interceptor:', error);
      // Handle the error as needed, e.g., show a notification or redirect
      if (error.status === 401) {
        toast.error('No tienes permiso para acceder a este recurso.');
      }
      if (error.status === 404) {
        toast.error('Recurso no encontrado.');
      }
      if (error.status === 500) {
        toast.error('Error interno del servidor.');
      }
      return throwError(() => new Error('An error occurred while processing the request.'));
    })
  );
};
